import * as Yup from "yup";

/**
 * Required-field validation for the campaign form ("Zapisz i aktywuj" flow).
 * "Zapisz jako szkic" skips this schema entirely and submits immediately.
 * Deliberately light -- only what's actually needed for the bot to run a
 * conversation, not every field the backend happens to accept.
 */
export const campaignValidationSchema = Yup.object({
    name: Yup.string().trim().required("Required"),

    products: Yup.array().of(
        Yup.object({
            name: Yup.string().trim().required("Required"),
            productType: Yup.string().required("Required"),
        })
    ),

    leadSourceConfig: Yup.object()
        .when("leadSourceType", {
            is: "GoogleSheets",
            then: (schema) => schema.shape({
                spreadsheetUrl: Yup.string().trim().required("Podaj URL arkusza Google Sheets"),
                sheetName: Yup.string().trim().required("Podaj nazwę zakładki"),
            }),
        })
        .when("leadSourceType", {
            is: "Excel",
            then: (schema) => schema.shape({
                excelFileUrl: Yup.string().trim().required("Podaj link do pliku Excel"),
                excelWorksheetName: Yup.string().trim().required("Podaj nazwę arkusza"),
            }),
        }),

    conversionGoals: Yup.array()
        .min(1, "Dodaj co najmniej jeden cel konwersji")
        .of(
            Yup.object({
                goalType: Yup.string().required("Required"),
            })
        ),

    communicationChannels: Yup.object({
        whatsApp: Yup.object({ enabled: Yup.boolean() }),
        sms: Yup.object({ enabled: Yup.boolean() }),
        email: Yup.object({ enabled: Yup.boolean() }),
    }).test(
        "at-least-one-channel",
        "Włącz co najmniej jeden kanał komunikacji",
        (cc) => !!(cc?.whatsApp?.enabled || cc?.sms?.enabled || cc?.email?.enabled)
    ),
});

/**
 * Maps each wizard step id to the top-level formik error keys that belong to it,
 * so the UI can flag which step needs attention on a failed "Zapisz i aktywuj".
 */
export const STEP_ERROR_FIELDS = {
    1: ["name"],
    2: ["leadSourceConfig"],
    3: ["products"],
    4: ["conversionGoals"],
    5: ["communicationChannels"],
    6: [],
    7: [],
    8: [],
};

export const stepHasErrors = (stepId, errors) => (STEP_ERROR_FIELDS[stepId] || []).some((field) => Boolean(errors[field]));
